import React, { Component, useEffect } from "react";
import Dashboard from "./Dashboard";
import DashboardBody from "./DashboardBody";
import { sendPushTokenForDevice } from "../../services/device";
import { getFirebaseToken } from "../../notifications/firebase";

export default function MangeDashboard({ children }) {
  useEffect(() => {
    const pushToken = window.localStorage.getItem("pushToken");
    if (pushToken && pushToken.length > 10) {
      sendPushTokenForDevice(pushToken)
        .then(async ({ data }) => {
          try {
            await getFirebaseToken();
          } catch (e) {}
        })
        .catch((e) => {});
    }
  }, []);
  return (
    <>
      <Dashboard />
      <DashboardBody>{children}</DashboardBody>
    </>
  );
}
